import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Скрол до верху при зміні маршруту
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Або 'smooth' для плавного скролу
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
